export const messagingUrl = {
  SEND_MESSAGE: "send-message",
  PREVIOUS_MESSAGES: "previous-messages",
  VIEW_PREVIOUS_MESSAGE: "view-previous-message",
};
